export const INTERVAL_EXERCISE_TYPE = 'INTERVAL';
export const TRANSCRIPTION_EXERCISE_TYPE = 'TRANSCRIPTION';
export const MIXER_EXERCISE_TYPE = 'MIXER';
export const EQ_EXERCISE_TYPE = 'EQ';
